import { render } from "./ProfileInstagram.vue?vue&type=template&id=148435b1&scoped=true"
import script from "./ProfileInstagram.vue?vue&type=script&lang=js"
export * from "./ProfileInstagram.vue?vue&type=script&lang=js"

import "./ProfileInstagram.vue?vue&type=style&index=0&id=148435b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148435b1"]])

export default __exports__